import React, { Component } from 'react';

import './Modal.css';
import Close from '../Icons/Close.svg';
import Loader from '../Icons/Loader';

class ModalBack extends Component {

	constructor(props) {
	    super(props);
	    this.hideModal = this.hideModal.bind(this);
	}

	hideModal() {
		this.props.actions.hideModal();
	}

	validAction(){
		if(this.props.type === 'cancelBacking'){
			this.props.messageInfo();
			this.props.backFormValid();
			this.props.cancelBacking();
		}
	}

  	render() {
	    return (
			<div>
				<div className="modalBackground" onClick={() => this.hideModal()} ></div>
				<div className="modalContainer alert">
					<div className="modalBloc">
						<div className="close" onClick={() => this.hideModal()} ><img src={Close} alt="Close" /></div>
						<div className="content">
							<div className="title">Are you sure?</div>
							<div className="actions">
								<div className="button is-abort" onClick={() => this.hideModal()} >No, abort!</div>
								<button className="button is-primary" disabled={this.props.backingIsLoading} onClick={() => this.validAction()}>{this.props.backingIsLoading ? <Loader color="#fff" /> : 'Yes, do it!'}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default ModalBack;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalAlert.js